<!--
 * @Author: your name
 * @Date: 2020-07-22 16:47:26
 * @LastEditTime: 2021-01-11 14:19:27
 * @LastEditors: Please set LastEditors
 * @Description: 判断题 C
 * @FilePath: \vue-gaokao-ebook\src\components\question-type\judge_question.vue
--> 
<template>

  <!-- 判断题  -->
  <div :class="isComposite ? 'question-c' : 'question'" :id="'anchor' + q.id">
    <template v-if="selfAssessment">
      <assessment :composite-original="compositeTypeId" :composite-type-id="compositeTypeId"
        :is-show-correct-btn="isShowCorrectBtn" :composite-name="compositeName" :is-composite="isComposite"
        :question="question" :show-analysis="showAnalysis"></assessment>
    </template>
    <template v-else>
      <correctionTitle v-if="q.typeId == 39" :font-size="fontSize" :question="question"
        :id="!isComposite ? 'sticky' + q.id : ''" :is-composite="isComposite"></correctionTitle>
      <lineTitle v-else-if="q.typeId == 230" :font-size="fontSize" :question="question"
        :id="!isComposite ? 'sticky' + q.id : ''" :is-composite="isComposite"></lineTitle>
      <baseTitle v-else :composite-type="compositeType" :font-size="fontSize" :composite-name="compositeName"
        :question="question" :id="!isComposite ? 'sticky' + q.id : ''" :is-composite="isComposite"></baseTitle>
    </template>


    <template v-if="question.typeId == 39">
      <!-- q-tab 是当前展示的某一项的下标 -->
      <correctionAnswerArea v-if="isShowAnswerArea" :question="question" :is-show-self-answer="isShowSelfAnswer"
        :isComposite="isComposite" :q-tab="+qTab"></correctionAnswerArea>
    </template>
    <!-- 连线题 -->
    <template v-else-if="question.typeId == 230">
      <!-- q-tab 是当前展示的某一项的下标 -->
      <lineAnswerArea v-if="isShowAnswerArea" :question="question" :is-show-self-answer="isShowSelfAnswer"
        :isComposite="isComposite" :q-tab="+qTab"></lineAnswerArea>
    </template>
    <template v-else>
      <template v-if="major_question_code.indexOf(question.typeCode) == -1">
        <baseAnswerArea v-if="isShowAnswerArea" :question="question" :is-show-self-answer="isShowSelfAnswer"
          :isDisable="isDisable" :isComposite="isComposite"></baseAnswerArea>
      </template>
      <template v-else>
        <baseAnswerArea v-if="isShowAnswerArea" :isDisable="isDisable" :question="question"
          :is-show-self-answer="isShowSelfAnswer" :isComposite="isComposite"></baseAnswerArea>
      </template>
    </template>

  </div>
</template>

<script>
import questionHandle from "@/assets/js/question-handle";
import baseAnswerArea from "@/components/paper/question/answer_area/base_answer_area";
import correctionAnswerArea from "@/components/paper/question/answer_area/correction_answer_area";
import lineAnswerArea from "@/components/paper/question/answer_area/line_answer_area";
import baseTitle from "@/components/paper/question/title/base_title"
import correctionTitle from "@/components/paper/question/title/correction_title"
import lineTitle from "@/components/paper/question/title/line_title"
import assessment from "@/components/paper/question/assessment/assessment.vue"
export default {
  name: "base_question",
  data() {
    return {
      q: {},
      choose_option: "",
      major_question_code: ["S", "E"]
    };
  },
  components: {
    baseAnswerArea,
    baseTitle,
    correctionAnswerArea,
    assessment,
    correctionTitle,
    lineAnswerArea,
    lineTitle
  },
  props: {
    isComposite: {
      type: Boolean,
      default: false,
    },
    compositeName: {
      type: String,
      default: '复合题'
    },
    question: {
      type: Object,
    },
    isDisable: {
      type: Boolean,

      default: false,
    },
    selfAssessment: {
      type: Boolean,
      default: false
    },
    isShowAnswerArea: {
      type: Boolean,
      default: true
    },
    isShowCorrectBtn: {
      type: Boolean,
      default: true
    },
    isShowSelfAnswer: {
      type: Boolean,
      default: false
    },
    fontSize: {
      type: Number,
      default: 24
    },
    showAnalysis: {
      type: Boolean,
      default: true
    },
    qTab: {
      type: Number,
      default: 0
    },
    compositeType: {
      type: Number
    },
    compositeTypeId: {
      type: Number
    },
    compositeId: {
      type: Number
    }
  },
  methods: {
    formatQuestion(ques) {
      this.q = questionHandle.formatQuestion(ques);
    },
  },


  mounted() {
    this.formatQuestion(this.question);

  }
}
</script>

<style lang="stylus" scoped>
.border_bottom {
  // border-bottom: 30px #f5f5f5 solid;
}
.question {
  margin-top : 30px;
  width: 1531px;
  position: relative;
  margin-left : 30px;
  padding-bottom: 30px;
}
.question-c {
  width: 1531px;
  position: relative;
  margin-left : -92px;
}
</style>